export default __webpack_public_path__ + "static/media/paypal.e195319c.svg";